/** Safe JSON-LD inside an HTML script, including text supplied by the CMS. */
export function serializeJsonLd(value: unknown): string {
    return JSON.stringify(value).replace(/</g, '\\u003c');
}

export function schemaText(value: unknown): string {
    if (typeof value !== 'string') return '';
    const entities: Record<string, string> = {
        lt: '<', gt: '>', amp: '&', quot: '\"', apos: "'", nbsp: ' ',
        ndash: '–', mdash: '—', laquo: '«', raquo: '»', hellip: '…',
    };
    const decoded = value.replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, (match, entity: string) => {
        if (entity.startsWith('#')) {
            const code = entity[1].toLowerCase() === 'x'
                ? parseInt(entity.slice(2), 16) : parseInt(entity.slice(1), 10);
            return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : match;
        }
        return entities[entity.toLowerCase()] ?? match;
    });
    return decoded.replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
        .replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function publicSchemaUrl(value: unknown, siteUrl: string): string | undefined {
    if (typeof value !== 'string' || !value.trim()) return undefined;
    try {
        const url = new URL(value, siteUrl);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined;
    } catch { return undefined; }
}
